const data = Object.freeze({
  Draft: 1,
  Submitted: 2,
  Validated: 3,
  Rejected: 4,
  Cancelled: 5,
  Reviewed: 6,
});

export const names = Object.freeze({
  [data.Draft]: 'Borrador',
  [data.Submitted]: 'Enviado',
  [data.Validated]: 'Validado',
  [data.Rejected]: 'Rechazado',
  [data.Cancelled]: 'Cancelado',
  [data.Reviewed]: 'Revisado',
});
export default data;
